<template>
	<nav class="navbar is-primary" id="navbar">
		<div class="navbar-brand">
			<div calss="navbar-item">
				<figure class="image">
					<img :src="Logo" alt="EFO">
				</figure>
			</div>

			<div class="navbar-burger" data-target="navMenu">
				<span></span>
				<span></span>
				<span></span>
			</div>
		</div>
		<div class="navbar-menu" id="navMenu">
			<div class="navbar-start">
				<!-- navbar items -->
				<div class="navbar-item">
					<div class="level" style="padding-left:5px;">
						<div class="level-left">
							<div class="level-item">
								<h4 v-if="this.user.tbl_sys_role.id == 4" class="title is-4 has-text-white">Beheerder &nbsp;</h4>
								<h4 v-if="this.user.tbl_sys_role.id > 4" class="title is-4 has-text-white">In beroep </h4>
								<h4
									v-else
									class="title is-4 has-text-white"
								>{{(user.tbl_sys_user.tbl_school.tbl_conf_schoolboard ? user.tbl_sys_user.tbl_school.tbl_conf_schoolboard.abbriviation : '')}} - {{user.tbl_sys_user.tbl_school.name}} - Schoolnummer : {{user.tbl_sys_user.tbl_school.schoolnumber}}</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="navbar-end">
				<b-dropdown position="is-bottom-left">
					<a class="navbar-item button is-primary" slot="trigger">
						<span>{{user.tbl_sys_user.displayname}} ({{user.tbl_sys_user.username}})&nbsp;</span>
						<b-icon icon="account-circle"></b-icon>
					</a>
					<b-dropdown-item custom>
						<div class="level">
							<div class="level-left">
								<div class="level-item">
									<b-icon icon="account" style="padding-right: 10px;"></b-icon>
									{{user.tbl_sys_role.name}} : {{user.firstname}} {{user.lastname}}
								</div>
							</div>
						</div>
					</b-dropdown-item>
					<hr class="dropdown-divider">
					<b-dropdown-item value="settings">
						<div class="level">
							<div class="level-left">
								<div class="level-item">
									<b-icon icon="cogs" style="padding-right: 10px;"></b-icon>Gebruikers Gegevens
								</div>
							</div>
						</div>
					</b-dropdown-item>
					<b-dropdown-item value="logout" @click="clickLogout()">
						<div class="level">
							<div class="level-left">
								<div class="level-item">
									<b-icon icon="logout" style="padding-right: 10px;"></b-icon>Uitloggen
								</div>
							</div>
						</div>
					</b-dropdown-item>
				</b-dropdown>
			</div>
		</div>
	</nav>
</template>

<script>
import logo from "../assets/Logo_EFO.png";
import Cookies from "js-cookie";

export default {
	name: "navbar",
	data: function() {
		return {
			access: Cookies.get("access"),
			user: Cookies.getJSON("user"),
			school: [],
			Logo: logo
		};
	},
	created() {
		console.log("CREATED NAVBAR!");
	},
	computed: {
		// user() {
		//   return this.$store.getters.getUser;
		// },
		// firstlogin() {
		//   return this.$store.getters.getFirstlogin;
		// }
	},
	methods: {
		handleEdit(index, row) {
			console.log(index, row);
		},
		clickLogout() {
			this.$store.dispatch("logout");

			this.$router.push({
				path: "/"
			});
		},
		onPagination: function() {}
	}
};
</script>
<style scoped>
</style>
